import { useTranslation } from 'next-i18next';

import { IBlogItemOverview } from 'common/types/blog';
import { BlogItem } from '../BlogItem';

export const BlogList: React.FC = () => {
  const { t } = useTranslation('blogItemsOverview');
  const blogs: IBlogItemOverview[] = t('blogItems', { returnObjects: true });

  const renderBlogItem = (blog: IBlogItemOverview) => {
    return <BlogItem key={blog.slug} blog={blog} />;
  };

  if (!blogs?.length) {
    return <></>;
  }
  return (
    <section className="bg-gradient relative flex w-full items-center overflow-hidden pb-6 pt-20 md:pt-24 lg:pb-10 lg:pt-32">
      <div className="container">
        <div className="grid gap-6 gap-x-2 pb-16 text-black md:pb-24 lg:grid-cols-2 lg:pb-32">
          {blogs.map(renderBlogItem)}
        </div>
      </div>
    </section>
  );
};
